import React, { useContext, createContext, useMemo, useState } from 'react';

const DataProviderContext = createContext();

export const useDataProvider = () => {
  const context = useContext(DataProviderContext);
  return context;
};

export const DataProvider = ({ children }) => {
  const [practiceArea, setPracticeArea] = useState([]);
  const [venueOptions, setVenueOptions] = useState([]);
  const [conferenceRoomOptions, setConferenceRoomOptions] = useState([]);
  const [tagList, setTagList] = useState(null);
  const [caseStageList, setCaseStageList] = useState([]);
  const [leadStages, setLeadStages] = useState([]);
  const [caseMatterList, setCaseMatterList] = useState([]);
  const [eventLocations, setEventLocations] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [activityTypes, setActivityTypes] = useState([]);
  const [timerList, setTimerList] = useState([]);
  // Session-level cache flags — survive component remounts (Layout remounts on every route
  // change) but are reset on logout via clearAllData().
  const [timerListLoaded, setTimerListLoaded] = useState(false);
  const [timerCasesList, setTimerCasesList] = useState([]);
  const [timerCasesListLoaded, setTimerCasesListLoaded] = useState(false);

  const clearAllData = () => {
    setPracticeArea([]);
    setVenueOptions([]);
    setConferenceRoomOptions([]);
    setTagList(null);
    setCaseStageList([]);
    setLeadStages([]);
    setCaseMatterList([]);
    setEventLocations([]);
    setTypeList([]);
    setActivityTypes([]);
    setTimerList([]);
    setTimerListLoaded(false);
    setTimerCasesList([]);
    setTimerCasesListLoaded(false);
  };

  const values = useMemo(
    () => ({
      practiceArea,
      setPracticeArea,
      venueOptions,
      setVenueOptions,
      conferenceRoomOptions,
      setConferenceRoomOptions,
      tagList,
      setTagList,
      caseStageList,
      setCaseStageList,
      leadStages,
      setLeadStages,
      caseMatterList,
      setCaseMatterList,
      eventLocations,
      setEventLocations,
      typeList,
      setTypeList,
      clearAllData,
      activityTypes,
      setActivityTypes,
      timerList,
      setTimerList,
      timerListLoaded,
      setTimerListLoaded,
      timerCasesList,
      setTimerCasesList,
      timerCasesListLoaded,
      setTimerCasesListLoaded,
    }),
    [
      practiceArea,
      venueOptions,
      conferenceRoomOptions,
      tagList,
      caseStageList,
      leadStages,
      caseMatterList,
      eventLocations,
      typeList,
      timerList,
      timerListLoaded,
      timerCasesList,
      timerCasesListLoaded,
      activityTypes,
    ]
  );

  return <DataProviderContext.Provider value={values}>{children}</DataProviderContext.Provider>;
};
